







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
	// --- data

	public focus: boolean = false;

	// --- props

	@Prop({ default: false, type: Boolean }) public readonly value!: boolean;

	// --- computed

	get model(): boolean {
		return this.value;
	}

	set model(value: boolean) {
		this.$emit('input', value);
	}
}
